var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyciemaszynoweIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.78 47.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.31,47.78h2.8v-3.27h13.87v3.27h2.8v-8.49h-19.47v8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.74,18.91v-9.49c0-3.39-2.76-6.14-6.14-6.14h-3.1c-3.39,0-6.14,2.76-6.14,6.14v9.49h-2.04v4.29h5.39v.87c0,2.39,1.95,4.34,4.34,4.34s4.34-1.95,4.34-4.34v-.87h5.39v-4.29h-2.04ZM36.5,6.08h3.1c1.69,0,3.09,1.26,3.31,2.89h-9.73c.22-1.63,1.62-2.89,3.31-2.89ZM39.45,26h-2.8v-2.8h2.8v2.8ZM42.94,18.91h-9.79v-7.14h9.79v7.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.05,31.21c-3.27,0-6.03-2.21-6.88-5.21h-2.86v10.49h19.47v-10.49h-2.86c-.84,3-3.61,5.21-6.88,5.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.24,27.72v11.49c0,2.17-1.65,3.95-3.76,4.18v-1.55h-4.12v-6.41h-6.41v-10.44h-1.57V5.6c.94-.5,1.57-1.49,1.57-2.62V0H0v2.97c0,1.14.64,2.12,1.57,2.62v19.39H0v20c0,1.55,1.25,2.8,2.8,2.8h13.68v-1.59c3.65-.23,6.55-3.27,6.55-6.98v-11.49c0-1.7,1.02-3.17,2.48-3.83v-2.96c-3.03.77-5.28,3.52-5.28,6.78h0ZM9.56,41.83h-3.61v-3.61h3.61v3.61h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyciemaszynoweIcon);
export default __webpack_public_path__ + "static/media/Mycie maszynowe_icon.15ecda243fa3cfce4bff54adc16ed744.svg";
export { ForwardRef as ReactComponent };